var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Grid, GridColumn, List, ListItem } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import config from '../Config';
import { addLanguageSlugToUrl } from '../util/PathUtil';
import { frontPageGaData } from './FrontPageBlocks';
import { injectStores } from '../util/StoresUtil';
const BLOCK_NAME = 'Teenused';
let ServicesBlock = class ServicesBlock extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate, currentLanguage } = this.translateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(List, { type: "unstyled", bordered: true },
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.servicesUrl, currentLanguage), link: true, text: translate('servicesBlock.services'), iconLeft: "#mobile", onClick: () => frontPageGaData(BLOCK_NAME, 'Teenused') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.additionalMobileData, currentLanguage), link: true, text: translate('servicesBlock.additionalMobileData'), iconLeft: "#chart-pie", onClick: () => frontPageGaData(BLOCK_NAME, 'Interneti lisamaht') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.additionalServicesUrl, currentLanguage), link: true, text: translate('servicesBlock.additionalServices'), iconLeft: "#service-other", onClick: () => frontPageGaData(BLOCK_NAME, 'Veel lisateenuseid') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.currentMonthBalanceUrl, currentLanguage), link: true, text: translate('servicesBlock.currentMonthBalance'), iconLeft: "#stocks-up", onClick: () => frontPageGaData(BLOCK_NAME, 'Jooksva kuu saldo') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.packetUrl, currentLanguage), link: true, text: translate('servicesBlock.packetInfo'), iconLeft: "#file-check-simple", onClick: () => frontPageGaData(BLOCK_NAME, 'Paketi info') }))),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xs-12'] },
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.newServiceUrl, currentLanguage), text: translate('servicesBlock.newService'), size: "small", onClick: () => frontPageGaData(BLOCK_NAME, 'Liitu uue mobiiliteenusega') })),
                React.createElement(GridColumn, { width: ['xs-12'] },
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.packetUrl, currentLanguage), text: translate('servicesBlock.changePacket'), size: "small", onClick: () => frontPageGaData(BLOCK_NAME, 'Vaheta paketti') })))));
    }
};
ServicesBlock = __decorate([
    injectStores,
    observer
], ServicesBlock);
export default ServicesBlock;
